import { render } from "./Material.vue?vue&type=template&id=6dd2ea40"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"

import "./Material.vue?vue&type=style&index=0&id=6dd2ea40&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__